<div class="profile-container">
    <div class="">
        <div class="profile-content">

          <div class="header-block">
            <div class="header-title">
                <p>{{taskType | titlecase}} Tasks Posted By Me</p>
            </div>
            <div class="add-block">
              <div class="search">
                <form autocomplete="off" >
                  <input type="text" placeholder="Filter here" (keyup)="taskFilterByWildSearch(search.value)" #search [(ngModel)]="searchFilter" [ngModelOptions]="{standalone: true}">
                </form>

            </div>
            <button (click)="searchclear()">Reset</button>

        </div>
          </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 dataListStatus">
                <ul>
                  <li class="cp" (click)="getAllByCreatedBy(0,10)">ALL TASKS<span class="New">{{Total_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('NEW')">NEW <span class="New">{{NEW_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('ASSIGNED')">ASSIGNED <span class="Work-In-Progress">{{ASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('REASSIGNED')">REASSIGNED <span class="Pending">{{REASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('WORK_IN_PROGRESS')">WORK_IN_PROGRESS <span class="Completed">{{WORK_IN_PROGRESS_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PENDING')">PENDING <span class="Deferred">{{PENDING_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('COMPLETED')">COMPLETED <span class="Deferred">{{COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('DEFERRED')">DEFERRED <span class="Deferred">{{DEFERRED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PARTIALLY_COMPLETED')">PARTIALLY_COMPLETED <span class="Deferred">{{PARTIALLY_COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('FORCE_CLOSED')">FORCE_CLOSED <span class="Deferred">{{FORCE_CLOSED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('CLOSED')">CLOSED <span class="Deferred">{{CLOSED_tasksCount}}</span></li>
                </ul>
              </div>
              <div class="col-lg-9 col-md-9 dataList" style="margin:0;padding: 0;">
                <!-- <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4>{{taskType}} TASKS POSTED BY ME</h4>
                  </div>
                  <div class="dataList-header-right">
                    <input type="text" placeholder="Filter here" (keyup)="taskFilterByWildSearch(search.value)" #search [(ngModel)]="searchFilter">
                    <button (click)="searchclear()">Reset</button>

                  </div>
                </div> -->
                <div class="dataList-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 75%;">Description</th>
                        <th style="width: 10%;">Action</th>
                      </tr>
                    </thead>
                    <!-- <tbody>
                      <tr *ngFor="let task of tasks | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      }">
                        <td>{{task.name}}</td>
                        <td>{{task.description}}</td>
                        <td>
                          <svg xmlns="http://www.w3.org/2000/svg"   width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="del(task.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="getSingleTask(task.taskId)" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg> 
                        </td>
                      </tr>
                    </tbody> -->
                  </table>

                  <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let task of tasks | paginate : {
                          itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">
        
                          <p style="width: 25%;">{{task.name}}</p>
                          <p style="width: 60%;">{{task.description}}</p>
                          <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                            <svg xmlns="http://www.w3.org/2000/svg"   width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" (click)="del(task.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" (click)="getSingleTask(task.taskId)" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                            </svg> 
                          </p>
        
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && tasks.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>

                  <!-- <div class="pagination-block" *ngIf="tasks.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div *ngIf="tasks.length == 0">
                    <p class="text-center">No records found.</p> 
                  </div>-->
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
          <div class="row">
            
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Task Name</label>
                <input formControlName="name" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea name="" formControlName="description" id="" style="height: 70px"  class="form-control" cols="30" rows="10"></textarea>
              </div>
            </div>
            

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Assign To</label>
                <select class="form-control" formControlName="assignedTo">
                  <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group ">
                <label>Tag Users</label>
                <ng-multiselect-dropdown
                [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                [settings]="tagUsersdropdownSettings"
                [data]="tagUsersdropdownList"
                [(ngModel)]="tagUsersselectedItems"
                class="form-control"
                style="padding: 0;border: none"
                (onSelect)="onItemSelect($event)"
                (onSelectAll)="onSelectAll($event)"
                >
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Exp Start Date</label>
                <input formControlName="taskExpStartDate" type="date" class="form-control">
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Exp End Date</label>
                <input formControlName="taskExpEndDate" type="date" class="form-control">
              </div>
            </div>
           

            
          </div>

  
            <div class="col-lg-12" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <!-- <span>Select Image</span> -->
                    <input #imageInput
                           type="file" id="add-image-btn"
                           accept="image/*" hidden="true"
                           (change)="onSelectFile($event)">
                </label>
              </div>
              <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addImageBtn()">
                    <span>+ Add Image</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;" *ngFor="let image of images" class="mr-2">
                      <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                  </div>
              </div>
            
              <div class="" style="margin: 0;padding: 0;" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <!-- <span>Select video</span> -->
                    <input #imageInput
                          type="file" id="add-video-btn"
                          accept="video/*" hidden="true"
                          (change)="onSelectFile($event)">
                  </label>
              </div>
              <div class=" media-content">
                <div class="mr-2 image-btn" (click)="addVideoBtn()">
                  <span>+ Add video</span>
                </div>
                <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                    <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                </div>
              </div>
            
              <div class="" style="margin: 0;padding: 0;" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <!-- <span>Select video</span> -->
                    <input #imageInput
                          type="file" id="add-audio-btn"
                          accept="audio/*" hidden="true"
                          (change)="onSelectFile($event)">
                  </label>
              </div>
              <div class=" media-content">
                <div class="mr-2 image-btn" (click)="addAudioBtn()">
                  <span>+ Add Audio</span>
                </div>
                <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                    <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                </div>
              </div>
            
              <div *ngFor="let audio of audios" class="mr-2">
                <audio controls>
                  <source src="{{audio}}" type="audio/mpeg">
                </audio>
              </div>
          </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" (click)="cancelModel()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addTask()" class="btn btn-primary">Add Task</button>
      </div>
    </div>
  </div>
  </div>
  </div>
  
<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
          <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteTask()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>
  
  <!-- <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="" *ngFor="let task of task">
          <div class="jobs-posted-data">
            <div class="label">
              <p>Task Name</p>
            </div>
            <div class="dts">
              <p>:</p>
            </div>
            <div class="data">
              <p>{{task.name}}</p>
            </div>
          </div>
          <div class="jobs-posted-data">
            <div class="label">
              <p>Task Description</p>
            </div>
            <div class="dts">
              <p>:</p>
            </div>
            <div class="data">
              <p>{{task.description}}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </div> -->


<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="task-content">
          <div class="c-button">
            <div class="c-right">
              <h4> <span style="margin-right: 15px;" *ngIf="ticketId != null && ticketId != ''">TicketId: <span data-toggle="modal" data-target="#ticketview" style="color:rgb(89, 169, 234);cursor: pointer;">{{ticketId}}</span></span> Tasks:</h4>
            </div>
            <div style="align-items: center;">
              <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
         <div class="task-data">
    
          <ul class="task-header">
            <li style="width: 9%;">Task-Id</li>
            <li>Name</li>
            <li>Completed %</li>
            <li>Create on</li>
            <li style="width: 25%;text-align: center;">Status</li>
          </ul>
          <div class="task-table" *ngFor="let task of task;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.taskId}}</li>
              <li>{{task.name}}</li>
              <li style="padding-left: 10px"><input class="percentageInput" (focus)="TaskPercentage(completedPercentage.value)" (focusout)="updateTaskPercentage(completedPercentage.value,task.id)" type="number" #completedPercentage value="{{task.completedPercentage}}"> %</li>

              <li>{{task.createdDate | date}}</li>
              <li style="width: 25%;text-align: center;position: relative;background-color: white;">
                <span (click)="statusDropdown()" class="NEW">{{task.latestStatus}}
                </span>
                <div class="status-dropdown-list" id="status-dropdown-list">
                 <span>ASSIGNED</span>
                 <span>REASSIGNED</span>
                 <span>WORK_IN_PROGRESS</span>
                 <span>PENDING</span>
                 <span>COMPLETED</span>
                 <span>DEFERRED</span>
                 <span>PARTIALLY_COMPLETED</span>
                 <span>FORCE_CLOSED</span>
                 <span>CLOSED</span>
                </div>
              </li>
            </ul>
            <div class="dropdown-data" id="{{i}}">
              <div class="status-content" *ngIf="statusNote">
                <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note" class="form-control" id="" cols="30" rows="10"></textarea>
                <select name="" id="" (change)="taskStatusDropdown()" [(ngModel)]="taskStatus">
                  <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
                  <option value="PENDING">PENDING</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="DEFERRED">DEFERRED</option>
                  <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
                  <option value="FORCE_CLOSED">FORCE_CLOSED</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
                <button (click)="updateStatus(task.id)">update status</button>
              </div>
              <div class="assignedToAndTags">
                <div class="assignedTo">
                  <p> <span>Assign to</span> <span class="assignedToButton" *ngIf="task.latestStatus == 'NEW'" (click)="addClass('assignedTo')">: &nbsp; click here to assign</span> <span *ngIf="task.latestStatus != 'NEW'">: &nbsp; {{task.assignedToUserName}}</span> 
                    <span class="assignedToButton" *ngIf="task.latestStatus != 'NEW'" (click)="addClass('assignedTo')"> &nbsp; click here to re-assign</span> 
                  </p>
                </div>
                <div class="usersTaged">
                  <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
                  <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
                </div>
              </div>
              <p class="task-description"><span>Description :</span> {{task.description}}</p>

              <div class="assign-and-tag-data" id="assign-and-tag-data">
                <div class="assign-to-data">
                  <div class="panel panel-default assign-panel" *ngIf="addClassType == 'assignedTo'">
                    <div class="panel-heading">
                      <h3 class="panel-title">Assign To</h3>
                      <input type="text" class="form-control" [(ngModel)]="assignInput" placeholder="search user">
                    </div>
                    <div class="panel-body">
                      <div *ngIf="task.assignedToUserName == '' || task.assignedToUserName == null">
                        <span *ngFor="let user of usersList | filter: assignInput">
                          <p (click)="taskAssignToUser(task.id,user.userId,'ASSIGNED',user.userName)">{{user.userName}}</p>
                        </span>
                      </div>
                      <div *ngIf="task.assignedToUserName != ''">
                        <span *ngFor="let user of usersList | filter: assignInput">
                          <p (click)="taskAssignToUser(task.id,user.userId,'REASSIGNED',user.userName)">{{user.userName}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default usertags-panel" *ngIf="addClassType == 'usersTaged'">
                    <div class="panel-heading">
                      <h3 class="panel-title">Tag User</h3>
                    </div>
                    <div class="panel-body">
                      <div>
                        <span *ngFor="let user of usersList">
                          <p>{{user.userName}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="status-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 50%;">Note</th>
                      <th style="width: 20%;text-align: center;">Status</th>
                      <th style="width: 30%;text-align: center;">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let status of task.status">
                      <td style="width: 50%;">{{status.note}}</td>
                      <td style="width: 20%;text-align: center;">{{status.taskStatus}}</td>
                      <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="taskTable">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Exp start date</th>
                        <th scope="col">Exp end date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskExpStartDate | date:'medium'}}</td>
                        <td>{{task.taskExpEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Act start date</th>
                        <th scope="col">Act end date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskActStartDate | date:'medium'}}</td>
                        <td>{{task.taskActEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
</div>



<div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content">
        <div class="c-button">
          <div class="c-right">
            <h4>Ticket Id: #{{ticketId}}</h4>
            <!-- <div class="task-status-bar">
              <ul>
                <li class="activeStatus" (click)="activeStatus('All')" id="All">All</li>
                <li id="New">New</li>
                <li id="Completed">Completed</li>
                <li id="Pending">Pending</li>
                <li id="Canceled">Canceled</li>
              </ul>
            </div> -->
          </div>
          <div style="align-items: center;">
            <!-- <input type="text" name="" id=""> -->
            <!-- <svg  xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg> -->
            <!-- <svg data-toggle="modal" data-target="#taskAddModel" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
            <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg> -->
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </div>
        </div>
       <div class="task-data" *ngFor="let ticket of TicketData;">
        <ul class="task-header1">
          <li style="width: 20%;">Customer ID	</li>
          <li style="width: 20%;">Type	</li>
          <li style="width: 20%;">Subject</li>
          <!-- <li style="width: 25%;">Details	</li> -->
        
          <li style="width: 20%;">Status</li>
        </ul>
        <div class="task-table" style="margin-bottom: 10px;" >
          <ul>
            <li style="width: 20%;">{{ticket.customerID}}</li>
            <li style="width: 20%;">{{ticket.customerName}}</li>
            <li style="width: 20%;">{{ticket.heading}}</li>
            <!-- <li style="width: 25%;">{{ticket.details}}</li> -->
            
            <li style="width: 20%;text-align: center;position: relative;background-color: white;">
                  <span style="padding: 5px 10px;" class="NEW">{{ticket.latestTicketStatus}}
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg> -->
                  </span>
  
            </li>
          </ul>
        </div>
        <div class="details">
          <span>Details</span> <span>: &nbsp;</span> <span>{{ticket.details}}</span>
        </div>
        <div class="assignedToAndTags" *ngIf="ticket.assignedToUserName != '' && ticket.assignedToUserName != null">
          <div class="assignedTo">
            <p> <span>Assign to</span> <span>: {{ticket.assignedToUserName}}</span> 
               <!-- <span *ngIf="task.latestStatus != 'NEW'">: &nbsp; {{task.assignedToUserName}}</span>  -->
              <!-- <span class="assignedToButton" *ngIf="task.latestStatus != 'NEW'" (click)="addClass('assignedTo')"> &nbsp; click here to re-assign</span>  -->
            </p>
          </div>
          <!-- <div class="usersTaged">
            <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
            <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
          </div> -->
        </div>

        <div class="dropdown-data">  
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 50%;">Note</th>
                  <th style="width: 20%;text-align: center;">Status</th>
                  <th style="width: 30%;text-align: center;">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of ticket.ticketStatus;">
                  <td style="width: 50%;">{{status.note}}</td>
                  <td style="width: 20%;text-align: center;">{{status.ticketStatus}}</td>
                  <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                  <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
        </div>
 
       </div>
      </div>

    </div>
  </div>
  </div>